import { getSupportedInternalRouteInfo, redirect, removeAccountAwareRoutingParams } from './utils'

export const getRouteInfo = (url?: string) => {
  if (url == null || url === '') {
    return undefined
  }

  url = removeAccountAwareRoutingParams(url)

  let routeInfo = redirect({ url, target: '_blank' })

  const supportedInternalRoute = getSupportedInternalRouteInfo(url)
  if (supportedInternalRoute != null) {
    routeInfo = supportedInternalRoute
  }

  return routeInfo
}
